import { useSelector } from 'react-redux';
import { RootState } from '../../ReduxToolkit/Store';
import { Col } from 'reactstrap';
import HorizontalLogo from './HeaderLeft/HorizontalLogo';
import { H2, UL } from '../../AbstractElements';
import UserWrap from './HeaderRight/UserWrap';
import { useLocation } from 'react-router-dom';

export default function Header() {
    const { sideBarToggle } = useSelector((state: RootState) => state.layout);
    const userData = useSelector((state: RootState) => state.auth);
    const location = useLocation();

    return (
        <header className={`page-header row ${sideBarToggle ? 'close_icon' : ''}`}>
            <HorizontalLogo />
            <Col className="page-main-header d-flex align-items-center justify-content-between">
                {location.pathname === '/MMPDashboard' && (<H2 className="heading-color">
                    Welcome {userData?.sub?.split(' ')[0]}
                </H2>
                )}

                <H2 className="heading-color mx-auto text-center">
                    Mortgage Mastery Program
                </H2>
                <UL className="header-right simple-list flex-row">
                    <UserWrap />
                </UL>
            </Col>
        </header>
    );
}
